require('./_wks-define')('observable');



// WEBPACK FOOTER //
// ./~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js